import * as React from "react"
import { useState, useContext, useEffect } from "react"
import { Col } from "reactstrap"
import { useTranslation } from 'react-i18next'
import * as toastr from "toastr"
import Styled from 'styled-components'
import moment from 'moment'

import API from "Placements/API"
import getConfig from "Placements/Utils/GetRequestConfig.util"

import UserContext from "Placements/User.context"
import BoxWhite from 'Placements/Components/BoxWhite'
import Button from 'Placements/Components/Button'
import Dropdown from 'Placements/Components/Dropdown'
import { ContainerFlex } from "Placements/Styles/Global.style";


const DivTitle = Styled.div`
    text-align: center;
    position: relative;
    color: ${(props) => props.theme.main.mainBlue};
    margin: 0 auto;
`

const ButtonStyled = Styled(Button)`
    width: auto;    
    align-self: center;
    margin-bottom: -40px;
`
const DivStyled = Styled.div`
    max-width: 300px;
    margin: auto;
`


const Languages = [{ key: 1, value: 'Inglês' }, { key: 2, value: 'Espanhol' }]

const ChooseLanguage = () => {

    const { usuario }: any = useContext(UserContext)
    const [selectedLanguage, setSelectedLanguage] = useState(Languages[0]);

    const { t, i18n } = useTranslation()

    useEffect(() => {

        changeLanguage('en');

    }, []);

    const changeLanguage = (lng: any) => {
        i18n.changeLanguage(lng)
    };

    const HandleSelectChange = (e: any) => {
        setSelectedLanguage(e)
        switch (e.value) {
            case 'Inglês': changeLanguage('en'); break;
            case 'Espanhol': changeLanguage('es'); break;
            default: changeLanguage('en');
        }

    }

    const handleStart = () => {
        API.Test.Post({
            Data: moment().format('yyyy/MM/DD HH:mm:ss'),
            Id_Placement: selectedLanguage.key,
            Id_Usuario: usuario.Id_Usuario
        }, getConfig())
            .then((response: any) => {
                API.Sessao.Get({ idTesteUsuario: response.data.idTesteUsuario }, getConfig())
                    .then((resp: any) => {
                        localStorage.setItem("SessaoPl", JSON.stringify(resp.data))
                        window.location.href = "#/test"
                    }).catch((error: any) => {
                        toastr.error('Não foi possível carregar informações', error);
                    })
            })
            .catch((error: any) => {
                toastr.error('Não foi possível iniciar teste', error);
            })
    }

    return (
        <ContainerFlex>
            <Col md={8} className="mb-4">
                <BoxWhite >
                    <DivTitle className='title'>
                        Escolha um idioma
                    </DivTitle>
                    <div className="info">
                        <p>
                            Escolha o idioma para o qual você deseja realizar o teste de nível.
                        </p>
                        <DivStyled>
                            <Dropdown
                                value={selectedLanguage}
                                options={Languages}
                                onChange={HandleSelectChange} />
                        </DivStyled>
                    </div>

                    <DivTitle className='title'>
                        {t('instructions-header')}
                    </DivTitle>
                    <div className="info">
                        <p> {`O teste a seguir é composto de ${t('number-test-questions')} perguntas de múltipla escolha, envolvendo compreensão auditiva e escrita,
                        vocabulário e gramática. Se você tiver um ótimo desempenho pode ser direcionado ao próximo nível sem ter
                        de completar todas as ${t('number-test-questions')} questões.`}
                        </p>
                        <p> {`Para seguir adiante, clique em `}
                            <strong>{t('next-button')}</strong>
                            {` → ao final de cada página.`}
                        </p>
                        <p>
                            <strong>Pronto para começar? Boa sorte!</strong>
                        </p>
                    </div>
                    <ButtonStyled onClick={handleStart}>
                        {t('instructions-button')}
                    </ButtonStyled>
                </BoxWhite>
            </Col>
        </ContainerFlex>
    )
}

export default ChooseLanguage
